import React from "react";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <div className="page-height error">
      <div className="error-content">
        <h2>404</h2>
        <h3>Oops!</h3>
        <h4>Looks like the page you are looking for does not exit.</h4>
        <Link to="/">Go to Home Page</Link>
      </div>
    </div>
  );
};

export default Error;
